import * as actionTypes from './actionTypes';
import axios from 'axios';
import {IFC_LOOKUP_LIST_SET} from "./actionTypes";
export const ifcLookupListSet = (urlHospitalId, urlKeyword, urlFilter, urlPage, urlSortColumn, urlSortMode) => {
    return (dispatch, getState) => {
        console.log('[action/ifcLookupList] ifcLookupList', urlHospitalId, urlKeyword, urlFilter, urlPage, urlSortColumn, urlSortMode);
        dispatch({type: actionTypes.LOADING_START});

        const hospitalId = getState().auth.selectedHospital.id;
        dispatch({type: actionTypes.IFC_LOOKUP_LIST_SET, keyword: urlKeyword, page: urlPage, sortColumn: urlSortColumn, sortMode: urlSortMode })

        dispatch(ifcLookupListReload());
    }
};

export const ifcLookupListReload = () => {
    return (dispatch, getState) => {
        dispatch({type: actionTypes.LOADING_START});

        const idToken = getState().auth.idToken;
        const hospitalId = getState().auth.selectedHospital.id;
        const {keyword, filter, page, sortColumn, sortMode } = getState().ifcLookupList;

        console.log('[action/ifcLookupList] ifcLookupListReload', hospitalId, keyword, page, sortColumn, sortMode);

        let apiEndpoint = '';
        apiEndpoint = `/ifc-lookup/${hospitalId}`;

         if (keyword) {
            apiEndpoint += `&search=${keyword}`;
        }
        axios.get(
            apiEndpoint,
            {headers: {'Authorization': idToken}}
        )
            .then((response) => {
                dispatch({type: actionTypes.IFC_LOOKUP_LIST_SET, ...response.data})
                dispatch({type: actionTypes.LOADING_DONE});
            })
        ;
    }
};